module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-radio-group', {
    staticClass: "sdk_filter",
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('all'),
      "value": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('Pro Apps'),
      "value": "no_sdk"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "SDK",
      "value": "sdk"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3705a243"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/SdkFilter.vue
// module id = 1030
// module chunks = 1